import { getSocket, initSocketConnection } from "./socketClient";

/**
 * Ensures the shared app socket exists, then registers direct-chat listeners.
 * @returns {() => void} unsubscribe
 */
export function subscribeDirectChat(handlers) {
  const { onMessage, onTyping, onRead } = handlers;
  let s = getSocket();
  if (!s) {
    s = initSocketConnection(() => {});
  }
  if (!s) return () => {};

  if (onMessage) s.on("directChat:message", onMessage);
  if (onTyping) s.on("directChat:typing", onTyping);
  if (onRead) s.on("directChat:read", onRead);

  return () => {
    if (onMessage) s.off("directChat:message", onMessage);
    if (onTyping) s.off("directChat:typing", onTyping);
    if (onRead) s.off("directChat:read", onRead);
  };
}

export function emitDirectChatTyping(payload) {
  const s = getSocket();
  if (s?.connected) s.emit("directChat:typing", payload);
}
